// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Redirect = require("../../reason/common/Redirect.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let UnifiedProfileImageField = require("./UnifiedProfileImageField.bs.js");
let UnifiedProfileSettingsUI = require("./UnifiedProfileSettingsUI.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let UnifiedTeamAccountProfilePhotosSettingsQuery_graphql = require("../../__generated__/UnifiedTeamAccountProfilePhotosSettingsQuery_graphql.bs.js");

let convertVariables = UnifiedTeamAccountProfilePhotosSettingsQuery_graphql.Internal.convertVariables;

let convertResponse = UnifiedTeamAccountProfilePhotosSettingsQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = UnifiedTeamAccountProfilePhotosSettingsQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, UnifiedTeamAccountProfilePhotosSettingsQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, UnifiedTeamAccountProfilePhotosSettingsQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(UnifiedTeamAccountProfilePhotosSettingsQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(UnifiedTeamAccountProfilePhotosSettingsQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(UnifiedTeamAccountProfilePhotosSettingsQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(UnifiedTeamAccountProfilePhotosSettingsQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function UnifiedTeamAccountProfilePhotosSettings(props) {
  let match = use(undefined, undefined, undefined, undefined);
  let profile = match.currentAccountV5.profile;
  switch (profile.__typename) {
    case "IndividualAccountProfile" :
      return JsxRuntime.jsx(Redirect.make, {
        path: "/account/account_profile"
      });
    case "TeamAccountProfile" :
      return JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(UnifiedProfileSettingsUI.SubpageHeader.make, {
            title: "Photos",
            rootName: "Your Team's Profile",
            rootUrl: "/account/account_profile",
            url: "/account/account_profile/photos"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(UnifiedProfileImageField.make, {
                label: "Logo",
                helpText: "Upload a logo to display at the top of your marketing profile next to your team name.",
                url: Stdlib_Option.map(profile.logo, logo => logo.url),
                kind: "Logo"
              }),
              JsxRuntime.jsx(UnifiedProfileImageField.make, {
                label: "Team photo",
                helpText: "Upload a group photo that will appear in your marketing profile at full size.",
                url: Stdlib_Option.map(profile.unifiedTeamPhoto, photo => photo.url),
                kind: "TeamPhoto"
              })
            ],
            className: "divide-y divide-zinc-200"
          }),
          JsxRuntime.jsx(UnifiedProfileSettingsUI.FormActions.make, {
            publicUrl: profile.publicUrl,
            showSave: false
          })
        ],
        className: "space-y-8 rounded bg-white p-6 shadow-sm"
      });
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected account profile member: ` + profile._0);
  }
}

let make = UnifiedTeamAccountProfilePhotosSettings;

exports.Query = Query;
exports.make = make;
/* use Not a pure module */
